import { Icon, IconProps } from '../Icon'

export const ErrorIcon = ({ color, size = 16, fill }: IconProps) => {
  return (
    <Icon color={color} size={size} fill={fill}>
      error
    </Icon>
  )
}
